var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title,
        width: _vm.isZh ? "750px" : "850px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          attrs: {
            inline: true,
            "label-width": _vm.isZh ? "80px" : "130px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Parter")))]
                      ),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "230px" },
                        attrs: {
                          no: "partnerId",
                          disabled:
                            _vm.type === "renew" ||
                            _vm.readOnly ||
                            _vm.type === "edit",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          filterable: "",
                          "method-params": { active: true },
                          "default-value": _vm.contract.partnerId || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.contract.partnerId = p.value || 0
                            _vm.contract.branchId =
                              _vm.$store.getters.currentOfficeId
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_ContractNumber"))
                          )
                        ]
                      ),
                      _c("el-input", {
                        staticStyle: { width: "230px" },
                        attrs: { no: "contractNo", disabled: _vm.readOnly },
                        model: {
                          value: _vm.contract.contractNo,
                          callback: function($$v) {
                            _vm.$set(_vm.contract, "contractNo", $$v)
                          },
                          expression: "contract.contractNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.type === "edit" || _vm.type === "look"
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_CustomerLevel")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "230px" },
                              attrs: {
                                no: "customerType",
                                disabled: _vm.readOnly
                              },
                              model: {
                                value: _vm.contract.customerType,
                                callback: function($$v) {
                                  _vm.$set(_vm.contract, "customerType", $$v)
                                },
                                expression: "contract.customerType"
                              }
                            },
                            _vm._l(_vm.customerTypeList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label:
                                    _vm.$store.getters.language === "zh"
                                      ? item.chineseName
                                      : item.englishName,
                                  value: item.typeId
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_ContractStatus")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "230px" },
                              attrs: {
                                no: "contractState",
                                disabled: _vm.readOnly
                              },
                              model: {
                                value: _vm.contract.contractState,
                                callback: function($$v) {
                                  _vm.$set(_vm.contract, "contractState", $$v)
                                },
                                expression: "contract.contractState"
                              }
                            },
                            _vm._l(_vm.contractStateList, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label:
                                    _vm.$store.getters.language === "zh"
                                      ? item.chineseName
                                      : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_EffectiveDate")))]
                      ),
                      _c("el-date-picker", {
                        staticStyle: { width: "230px" },
                        attrs: {
                          no: "beginDate",
                          editable: false,
                          disabled: _vm.readOnly,
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.contract.beginDate,
                          callback: function($$v) {
                            _vm.$set(_vm.contract, "beginDate", $$v)
                          },
                          expression: "contract.beginDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_InvalidDate")))]
                      ),
                      _c("el-date-picker", {
                        staticStyle: { width: "230px" },
                        attrs: {
                          no: "endDate",
                          editable: false,
                          disabled: _vm.readOnly,
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.contract.endDate,
                          callback: function($$v) {
                            _vm.$set(_vm.contract, "endDate", $$v)
                          },
                          expression: "contract.endDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.type === "edit" || _vm.type === "look"
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_ContractType")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "230px" },
                              attrs: { no: "contractType", disabled: true },
                              model: {
                                value: _vm.contract.contractType,
                                callback: function($$v) {
                                  _vm.$set(_vm.contract, "contractType", $$v)
                                },
                                expression: "contract.contractType"
                              }
                            },
                            _vm._l(
                              _vm.ContractConstants.CONTRACT_TYPE,
                              function(item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label:
                                      _vm.$store.getters.language === "zh"
                                        ? item.chineseName
                                        : item.englishName,
                                    value: item.code
                                  }
                                })
                              }
                            ),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "0" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { disabled: _vm.type === "look" },
                              model: {
                                value: _vm.contract.clearCreditAtExpire,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.contract,
                                    "clearCreditAtExpire",
                                    $$v
                                  )
                                },
                                expression: "contract.clearCreditAtExpire"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("Information.ClearCreditExpiration")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_ApplicationRules")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "230px" },
                              attrs: {
                                no: "contractRuleUuid",
                                disabled: _vm.type === "look"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$forceUpdate()
                                }
                              },
                              model: {
                                value: _vm.contract.contractRuleUuid,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.contract,
                                    "contractRuleUuid",
                                    $$v
                                  )
                                },
                                expression: "contract.contractRuleUuid"
                              }
                            },
                            _vm._l(_vm.contractRuleDownList, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.uuid }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "0" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { disabled: _vm.editContactMultiple },
                              on: { change: _vm.contactMultipleChange },
                              model: {
                                value: _vm.cm.contactMultiple,
                                callback: function($$v) {
                                  _vm.$set(_vm.cm, "contactMultiple", $$v)
                                },
                                expression: "cm.contactMultiple"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_ContactMultiple"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.type === "add" || _vm.type === "renew"
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_ApplicationRules")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "230px" },
                              attrs: { no: "contractRuleUuid" },
                              on: {
                                change: function($event) {
                                  return _vm.$forceUpdate()
                                }
                              },
                              model: {
                                value: _vm.contract.contractRuleUuid,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.contract,
                                    "contractRuleUuid",
                                    $$v
                                  )
                                },
                                expression: "contract.contractRuleUuid"
                              }
                            },
                            _vm._l(_vm.contractRuleDownList, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.uuid }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "0" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.contract.clearCreditAtExpire,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.contract,
                                    "clearCreditAtExpire",
                                    $$v
                                  )
                                },
                                expression: "contract.clearCreditAtExpire"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("Information.ClearCreditExpiration")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "0" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { disabled: _vm.editContactMultiple },
                              on: { change: _vm.contactMultipleChange },
                              model: {
                                value: _vm.cm.contactMultiple,
                                callback: function($$v) {
                                  _vm.$set(_vm.cm, "contactMultiple", $$v)
                                },
                                expression: "cm.contactMultiple"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_ContactMultiple"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          !_vm.cm.contactMultiple
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_ContractAgreement")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-radio-group",
                            {
                              attrs: {
                                no: "contractAgreement",
                                disabled: _vm.readOnly
                              },
                              model: {
                                value: _vm.contract.contractAgreement,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.contract,
                                    "contractAgreement",
                                    $$v
                                  )
                                },
                                expression: "contract.contractAgreement"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_ClientContract")
                                  )
                                )
                              ]),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_SupplierContract")
                                  )
                                )
                              ]),
                              _c("el-radio", { attrs: { label: 3 } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "CargoMsg.Cargo_OverseasAgencyContract"
                                    )
                                  )
                                )
                              ]),
                              _c("el-radio", { attrs: { label: 9 } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_OtherContact"))
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.cm.contactMultiple
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_ContractAgreement")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-left": "2px" },
                              attrs: { disabled: _vm.editContactMultiple },
                              model: {
                                value: _vm.cm.clientContract,
                                callback: function($$v) {
                                  _vm.$set(_vm.cm, "clientContract", $$v)
                                },
                                expression: "cm.clientContract"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_ClientContract"))
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-left": "2px" },
                              attrs: { disabled: _vm.editContactMultiple },
                              model: {
                                value: _vm.cm.supplierContract,
                                callback: function($$v) {
                                  _vm.$set(_vm.cm, "supplierContract", $$v)
                                },
                                expression: "cm.supplierContract"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_SupplierContract")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-left": "2px" },
                              attrs: { disabled: _vm.editContactMultiple },
                              model: {
                                value: _vm.cm.overseasAgencyContract,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.cm,
                                    "overseasAgencyContract",
                                    $$v
                                  )
                                },
                                expression: "cm.overseasAgencyContract"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "CargoMsg.Cargo_OverseasAgencyContract"
                                  )
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-left": "2px" },
                              attrs: { disabled: _vm.editContactMultiple },
                              model: {
                                value: _vm.cm.otherContact,
                                callback: function($$v) {
                                  _vm.$set(_vm.cm, "otherContact", $$v)
                                },
                                expression: "cm.otherContact"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_OtherContact"))
                              )
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "title",
                              staticStyle: { "padding-left": "30px" }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning icon-tip",
                                attrs: {
                                  title: _vm.$t("CargoMsg.Cargo_ContractTip")
                                }
                              })
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "540px" },
                        attrs: {
                          no: "remarks",
                          type: "textarea",
                          rows: 3,
                          disabled: _vm.readOnly
                        },
                        model: {
                          value: _vm.contract.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.contract, "remarks", $$v)
                          },
                          expression: "contract.remarks"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("div", {
            staticStyle: {
              "border-bottom": "2px solid #E3E3E3",
              "margin-bottom": "10px",
              "margin-top": "10px"
            }
          }),
          _c(
            "span",
            { staticStyle: { "line-height": "25px", "font-weight": "bold" } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CurrentCredit")))]
          ),
          _vm.contract.contractRuleUuid === _vm.RULE_ALL_ORDERS.code
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Partners.limit") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "70px" },
                            attrs: {
                              no: "credit",
                              disabled: "",
                              min: 0,
                              precision: 0,
                              controls: false
                            },
                            model: {
                              value: _vm.contract.currentCredit,
                              callback: function($$v) {
                                _vm.$set(_vm.contract, "currentCredit", $$v)
                              },
                              expression: "contract.currentCredit"
                            }
                          }),
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                "margin-left": "5px",
                                width: "88px"
                              },
                              attrs: { no: "currency", disabled: "" },
                              model: {
                                value: _vm.contract.currentCurrency,
                                callback: function($$v) {
                                  _vm.$set(_vm.contract, "currentCurrency", $$v)
                                },
                                expression: "contract.currentCurrency"
                              }
                            },
                            _vm._l(_vm.currencySet, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.code, value: item.code }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Partners.accountPeriod") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "74px" },
                            attrs: {
                              no: "dateLimited",
                              disabled: "",
                              min: 0,
                              precision: 0,
                              controls: false
                            },
                            model: {
                              value: _vm.contract.currentDateLimited,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.contract,
                                  "currentDateLimited",
                                  $$v
                                )
                              },
                              expression: "contract.currentDateLimited"
                            }
                          }),
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                "margin-left": "5px",
                                width: "70px"
                              },
                              attrs: { no: "termUnit", disabled: "" },
                              model: {
                                value: _vm.contract.currentTermUnit,
                                callback: function($$v) {
                                  _vm.$set(_vm.contract, "currentTermUnit", $$v)
                                },
                                expression: "contract.currentTermUnit"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("Partners.day"),
                                  value: 0
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("Partners.week"),
                                  value: 1
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("Partners.month"),
                                  value: 2
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.contract.contractRuleUuid !== _vm.RULE_ALL_ORDERS.code
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Partners.limit") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "70px" },
                            attrs: {
                              no: "credit",
                              disabled: "",
                              min: 0,
                              precision: 0,
                              controls: false
                            },
                            model: {
                              value: _vm.contract.credit,
                              callback: function($$v) {
                                _vm.$set(_vm.contract, "credit", $$v)
                              },
                              expression: "contract.credit"
                            }
                          }),
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                "margin-left": "5px",
                                width: "88px"
                              },
                              attrs: { no: "currency", disabled: "" },
                              model: {
                                value: _vm.contract.currency,
                                callback: function($$v) {
                                  _vm.$set(_vm.contract, "currency", $$v)
                                },
                                expression: "contract.currency"
                              }
                            },
                            _vm._l(_vm.currencySet, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.code, value: item.code }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Partners.accountPeriod") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "74px" },
                            attrs: {
                              no: "dateLimited",
                              disabled: "",
                              min: 0,
                              precision: 0,
                              controls: false
                            },
                            model: {
                              value: _vm.contract.dateLimited,
                              callback: function($$v) {
                                _vm.$set(_vm.contract, "dateLimited", $$v)
                              },
                              expression: "contract.dateLimited"
                            }
                          }),
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                "margin-left": "5px",
                                width: "70px"
                              },
                              attrs: { no: "termUnit", disabled: "" },
                              model: {
                                value: _vm.contract.termUnit,
                                callback: function($$v) {
                                  _vm.$set(_vm.contract, "termUnit", $$v)
                                },
                                expression: "contract.termUnit"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("Partners.day"),
                                  value: 0
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("Partners.week"),
                                  value: 1
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("Partners.month"),
                                  value: 2
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c("div", {
            staticStyle: {
              "border-bottom": "2px solid #E3E3E3",
              "margin-bottom": "10px",
              "margin-top": "10px"
            }
          }),
          _c(
            "span",
            { staticStyle: { "line-height": "25px", "font-weight": "bold" } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ContractTerms")))]
          ),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.dateType") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "163px" },
                          attrs: { no: "dateType", disabled: _vm.readOnly },
                          model: {
                            value: _vm.contract.dateType,
                            callback: function($$v) {
                              _vm.$set(_vm.contract, "dateType", $$v)
                            },
                            expression: "contract.dateType"
                          }
                        },
                        _vm._l(_vm.dateTypeList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.$getLangColumn(item),
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.settlementMethod") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "cbType", disabled: _vm.readOnly },
                          model: {
                            value: _vm.cbType,
                            callback: function($$v) {
                              _vm.cbType = $$v
                            },
                            expression: "cbType"
                          }
                        },
                        _vm._l(_vm.cbTypeList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm.cbType === "n"
                    ? _c("el-input-number", {
                        staticStyle: { width: "70px" },
                        attrs: {
                          no: "tiDateSpecify",
                          disabled: _vm.readOnly,
                          value: _vm.tiDateSpecify || undefined,
                          min: 0,
                          max: 31,
                          precision: 0,
                          controls: false
                        },
                        on: {
                          input: function(val) {
                            this$1.tiDateSpecify = val
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.limit") } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "70px" },
                        attrs: {
                          no: "credit",
                          disabled: _vm.readOnly,
                          min: 0,
                          precision: 0,
                          controls: false
                        },
                        model: {
                          value: _vm.contract.snapCredit,
                          callback: function($$v) {
                            _vm.$set(_vm.contract, "snapCredit", $$v)
                          },
                          expression: "contract.snapCredit"
                        }
                      }),
                      _c(
                        "el-select",
                        {
                          staticStyle: { "margin-left": "5px", width: "88px" },
                          attrs: { no: "currency", disabled: _vm.readOnly },
                          on: { change: _vm.currencyChanged },
                          model: {
                            value: _vm.contract.currency,
                            callback: function($$v) {
                              _vm.$set(_vm.contract, "currency", $$v)
                            },
                            expression: "contract.currency"
                          }
                        },
                        _vm._l(_vm.currencySet, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.code, value: item.code }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.accountPeriod") } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "74px" },
                        attrs: {
                          no: "dateLimited",
                          disabled:
                            _vm.readOnly || _vm.showActualCreditGracePeriodDays,
                          min: 0,
                          precision: 0,
                          controls: false
                        },
                        model: {
                          value: _vm.contract.snapCreditDateLimited,
                          callback: function($$v) {
                            _vm.$set(_vm.contract, "snapCreditDateLimited", $$v)
                          },
                          expression: "contract.snapCreditDateLimited"
                        }
                      }),
                      _c(
                        "el-select",
                        {
                          staticStyle: { "margin-left": "5px", width: "70px" },
                          attrs: {
                            no: "termUnit",
                            disabled:
                              _vm.readOnly ||
                              _vm.showActualCreditGracePeriodDays
                          },
                          model: {
                            value: _vm.contract.termUnit,
                            callback: function($$v) {
                              _vm.$set(_vm.contract, "termUnit", $$v)
                            },
                            expression: "contract.termUnit"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: _vm.$t("Partners.day"), value: 0 }
                          }),
                          _c("el-option", {
                            attrs: { label: _vm.$t("Partners.week"), value: 1 }
                          }),
                          _c("el-option", {
                            attrs: { label: _vm.$t("Partners.month"), value: 2 }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showActualCreditGracePeriodDays,
                      expression: "showActualCreditGracePeriodDays"
                    }
                  ],
                  attrs: { span: 24 }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.paymentPeriod") } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "74px" },
                        attrs: {
                          no: "paymentTerm",
                          disabled: _vm.readOnly,
                          min: 0,
                          precision: 0,
                          controls: false
                        },
                        on: {
                          change: function(value) {
                            return _vm.changePaymentTerm(value)
                          }
                        },
                        model: {
                          value: _vm.contract.paymentTerm,
                          callback: function($$v) {
                            _vm.$set(_vm.contract, "paymentTerm", $$v)
                          },
                          expression: "contract.paymentTerm"
                        }
                      }),
                      _c(
                        "el-select",
                        {
                          staticStyle: { "margin-left": "5px", width: "70px" },
                          attrs: {
                            no: "paymentTermUnit",
                            disabled: _vm.readOnly
                          },
                          on: {
                            change: function(value) {
                              return _vm.changePaymentTermUnit(value)
                            }
                          },
                          model: {
                            value: _vm.contract.paymentTermUnit,
                            callback: function($$v) {
                              _vm.$set(_vm.contract, "paymentTermUnit", $$v)
                            },
                            expression: "contract.paymentTermUnit"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: _vm.$t("Partners.day"), value: 0 }
                          }),
                          _c("el-option", {
                            attrs: { label: _vm.$t("Partners.week"), value: 1 }
                          }),
                          _c("el-option", {
                            attrs: { label: _vm.$t("Partners.month"), value: 2 }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.settlementType") } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { no: "settlementByBill", disabled: true },
                          model: {
                            value: _vm.settlementByBill,
                            callback: function($$v) {
                              _vm.settlementByBill = $$v
                            },
                            expression: "settlementByBill"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v(_vm._s(_vm.$t("Partners.settlementByBill")))
                          ]),
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("Partners.settlementNotByBill") +
                                  "（" +
                                  _vm.$t(
                                    "CargoMsg.Cargo_SettlementMethodGreaterThan0"
                                  ) +
                                  "）"
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "postpone", disabled: _vm.readOnly },
                          model: {
                            value: _vm.contract.postpone,
                            callback: function($$v) {
                              _vm.$set(_vm.contract, "postpone", $$v)
                            },
                            expression: "contract.postpone"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("CargoMsg.Cargo_ExtensionAfterExpiration")
                            )
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm.contract.postpone
                    ? _c(
                        "span",
                        { staticStyle: { "margin-left": "20px" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_ExtensionCycle")
                              }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  attrs: {
                                    no: "postponeType",
                                    disabled: _vm.readOnly
                                  },
                                  on: { change: _vm.postponeTypeChangeHandler },
                                  model: {
                                    value: _vm.contract.postponeType,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.contract,
                                        "postponeType",
                                        $$v
                                      )
                                    },
                                    expression: "contract.postponeType"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("CargoMsg.Cargo_1Year"))
                                    )
                                  ]),
                                  _c("el-radio", { attrs: { label: 2 } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("CargoMsg.Cargo_2Years"))
                                    )
                                  ]),
                                  _c("el-radio", { attrs: { label: 3 } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("CargoMsg.Cargo_3Years"))
                                    )
                                  ]),
                                  _c("el-radio", { attrs: { label: 9 } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("CargoMsg.Cargo_Other"))
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.contract.postponeType === 9
                            ? _c("el-input-number", {
                                staticStyle: {
                                  width: "60px",
                                  "margin-right": "5px"
                                },
                                attrs: {
                                  no: "postponeLimited",
                                  disabled: _vm.readOnly,
                                  min: 0,
                                  precision: 0,
                                  controls: false
                                },
                                on: { change: _vm.postponeTypeChangeHandler },
                                model: {
                                  value: _vm.contract.postponeLimited,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.contract,
                                      "postponeLimited",
                                      $$v
                                    )
                                  },
                                  expression: "contract.postponeLimited"
                                }
                              })
                            : _vm._e(),
                          _vm.contract.postponeType === 9
                            ? _c(
                                "el-select",
                                {
                                  staticStyle: { width: "60px" },
                                  attrs: {
                                    no: "postponeUnit",
                                    disabled: _vm.readOnly
                                  },
                                  on: { change: _vm.postponeTypeChangeHandler },
                                  model: {
                                    value: _vm.contract.postponeUnit,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.contract,
                                        "postponeUnit",
                                        $$v
                                      )
                                    },
                                    expression: "contract.postponeUnit"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.day"),
                                      value: 0
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.week"),
                                      value: 1
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.month"),
                                      value: 2
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          staticStyle: {
            width: "100%",
            height: "100%",
            "margin-bottom": "8px"
          },
          attrs: { type: "card" },
          model: {
            value: _vm.activeTabName,
            callback: function($$v) {
              _vm.activeTabName = $$v
            },
            expression: "activeTabName"
          }
        },
        [
          _c(
            "el-tab-pane",
            {
              staticStyle: { width: "100%", height: "100%" },
              attrs: {
                lazy: true,
                label: _vm.$t("CargoMsg.Cargo_TempCredit"),
                name: "otherDocuments"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row row-grid",
                  staticStyle: { "min-height": "300px" }
                },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { height: "100%", "min-height": "220px" },
                    attrs: {
                      "column-defs": _vm.tempCreditInfo.columnDefs,
                      "grid-options": _vm.tempCreditInfo.gridOptions,
                      "row-data": _vm.tempCreditInfo.rowData,
                      "show-side-bar": false
                    }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c("span", [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_TempCreditNotice")))]),
      _c(
        "div",
        {
          staticStyle: { "text-align": "center" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _vm.type === "renew"
            ? _c(
                "el-button",
                {
                  attrs: {
                    no: "oneClickRenewal",
                    type: "primary",
                    disabled: _vm.saveBtnEnabled
                  },
                  on: { click: _vm.saveEventHander }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OneClickRenewal")))]
              )
            : _vm._e(),
          !_vm.readOnly && _vm.type !== "renew"
            ? _c(
                "el-button",
                {
                  attrs: {
                    no: "confirm",
                    type: "primary",
                    disabled: _vm.saveBtnEnabled
                  },
                  on: { click: _vm.saveEventHander }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [
              _vm._v(
                _vm._s(
                  !_vm.readOnly
                    ? _vm.$t("CargoMsg.Cargo_Cancel")
                    : _vm.$t("CargoMsg.Cargo_DisableOpen")
                )
              )
            ]
          )
        ],
        1
      ),
      _vm.contractApplyWindow.visible
        ? _c("contract-apply-dialog", {
            ref: "contractApplyDialog",
            attrs: {
              visible: _vm.contractApplyWindow.visible,
              "contract-bpm": _vm.contractApplyWindow.contractBpm,
              title: _vm.$t(
                "CargoMsg.Cargo_ContractApplicationApprovalProcess"
              ),
              type: "apply"
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.contractApplyWindow, "visible", $event)
              },
              close: function($event) {
                _vm.contractApplyWindow.visible = false
                _vm.saveBtnEnabled = false
              },
              closeAndRefresh: _vm.closeAndRefresh
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }